export default __webpack_public_path__ + "static/media/ic_traderjoe.aa0f5ef5.svg";